import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerTrigger } from "@/components/ui/drawer";
import { useMobileSize } from "@repo/common/hooks/use-mobile-size";
import { cn } from "@repo/common/utils/cn";
export function DialogToDrawer(t0) {
  const $ = _c(11);
  const {
    trigger,
    content,
    title,
    onOpenChange,
    dialogClasses,
    drawerClasses,
    open,
    repositionInputs: t1,
    closeButton
  } = t0;
  const repositionInputs = t1 === undefined ? undefined : t1;
  const isMobile = useMobileSize();
  let t2;
  if ($[0] !== closeButton || $[1] !== content || $[2] !== dialogClasses || $[3] !== drawerClasses || $[4] !== isMobile || $[5] !== onOpenChange || $[6] !== open || $[7] !== repositionInputs || $[8] !== title || $[9] !== trigger) {
    t2 = isMobile ? <Drawer open={open} onOpenChange={onOpenChange} repositionInputs={repositionInputs}><DrawerTrigger asChild={true}>{trigger}</DrawerTrigger><DrawerContent className="max-h-[85dvh] bg-white" CloseButton={closeButton}><DrawerHeader>{title && <DrawerTitle className="text-left" data-testid="drawer-title">{title}</DrawerTitle>}</DrawerHeader><div className="overflow-y-auto flex-1"><div className={cn("p-4 pt-0 flex flex-col", drawerClasses)}>{content}</div></div></DrawerContent></Drawer> : <Dialog open={open} onOpenChange={onOpenChange}><DialogTrigger asChild={true}>{trigger}</DialogTrigger><DialogContent className={cn("max-h-[90vh] w-full max-w-md overflow-y-auto bg-white", dialogClasses)} CloseButton={closeButton}>{title && <DialogTitle className="text-left mb-2" data-testid="dialog-title">{title}</DialogTitle>}{content}</DialogContent></Dialog>;
    $[0] = closeButton;
    $[1] = content;
    $[2] = dialogClasses;
    $[3] = drawerClasses;
    $[4] = isMobile;
    $[5] = onOpenChange;
    $[6] = open;
    $[7] = repositionInputs;
    $[8] = title;
    $[9] = trigger;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}